var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'',"title":'Set OTP'}}),_vm._v(" "),(!_vm.mobileMenu)?_c('otp-content'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4ab6218","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/pages/Otp.vue
// module id = yKTR
// module chunks = 0